import reducer from './reducers';

export { default as paymentSagas } from './sagas';
export { default as paymentActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/payment/index.js